import type * as Types from '../../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type AutocompleteNoPlacesQueryVariables = Types.Exact<{
  text: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type AutocompleteNoPlacesQuery = {
  __typename?: 'Query';
  results?: Array<
    | {
        __typename?: 'Event';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | { __typename?: 'Hashtag'; id: string; zoom?: number | null; hashtagName: string }
    | {
        __typename?: 'Sharry';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
    | {
        __typename?: 'User';
        id: string;
        name?: string | null;
        surname?: string | null;
        workAddress?: string | null;
        isProGold?: boolean | null;
        role: Types.UserRole;
        sharrylandPartner: boolean;
        isSmallOrganisation?: boolean | null;
        anonymised?: boolean | null;
        businessName?: string | null;
        slug?: string | null;
        fullname?: string | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        title?: string | null;
        subtitle?: string | null;
        slug?: string | null;
        contentType?: string | null;
        address?: string | null;
        shortAddress?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
      }
  > | null;
};

export type UserSearchesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSearchesQuery = {
  __typename?: 'Query';
  userSearches?: Array<{
    __typename?: 'UserSearch';
    id: string;
    searchString?: string | null;
    searchUrl?: string | null;
  }> | null;
};

export type SuggestedSearchesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SuggestedSearchesQuery = {
  __typename?: 'Query';
  suggestedSearches?: Array<{
    __typename?: 'SuggestedSearch';
    id: string;
    searchString?: string | null;
    searchUrl?: string | null;
  }> | null;
};

export type HeaderCategoriesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HeaderCategoriesQuery = {
  __typename?: 'Query';
  allCategories?: Array<{
    __typename?: 'Category';
    id?: string | null;
    name?: string | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    previewImage?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
};

export type AutocompleteNoPlacesEventFragment = {
  __typename?: 'Event';
  id: string;
  title?: string | null;
  subtitle?: string | null;
  slug?: string | null;
  contentType?: string | null;
  address?: string | null;
  shortAddress?: string | null;
  sharrySelection?: Types.SharrySelection | null;
  sharryKind?: {
    __typename?: 'SharryKind';
    id: string;
    name?: string | null;
    nameIt?: string | null;
    nameEn?: string | null;
    contentType?: Types.SharryContentType | null;
  } | null;
};

export type AutocompleteNoPlacesHashtagFragment = {
  __typename?: 'Hashtag';
  id: string;
  zoom?: number | null;
  hashtagName: string;
};

export type AutocompleteNoPlacesSharryFragment = {
  __typename?: 'Sharry';
  id: string;
  title?: string | null;
  subtitle?: string | null;
  slug?: string | null;
  contentType?: string | null;
  address?: string | null;
  shortAddress?: string | null;
  sharrySelection?: Types.SharrySelection | null;
  sharryKind?: {
    __typename?: 'SharryKind';
    id: string;
    name?: string | null;
    nameIt?: string | null;
    nameEn?: string | null;
    contentType?: Types.SharryContentType | null;
  } | null;
};

export type AutocompleteNoPlacesUserFragment = {
  __typename?: 'User';
  id: string;
  name?: string | null;
  surname?: string | null;
  workAddress?: string | null;
  isProGold?: boolean | null;
  role: Types.UserRole;
  sharrylandPartner: boolean;
  isSmallOrganisation?: boolean | null;
  anonymised?: boolean | null;
  businessName?: string | null;
  slug?: string | null;
  fullname?: string | null;
};

export type AutocompleteNoPlacesWonderFragment = {
  __typename?: 'Wonder';
  id: string;
  title?: string | null;
  subtitle?: string | null;
  slug?: string | null;
  contentType?: string | null;
  address?: string | null;
  shortAddress?: string | null;
  sharrySelection?: Types.SharrySelection | null;
  sharryKind?: {
    __typename?: 'SharryKind';
    id: string;
    name?: string | null;
    nameIt?: string | null;
    nameEn?: string | null;
    contentType?: Types.SharryContentType | null;
  } | null;
};

export type AutocompleteNoPlacesFragment =
  | AutocompleteNoPlacesEventFragment
  | AutocompleteNoPlacesHashtagFragment
  | AutocompleteNoPlacesSharryFragment
  | AutocompleteNoPlacesUserFragment
  | AutocompleteNoPlacesWonderFragment;

export const AutocompleteNoPlacesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompleteNoPlaces' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutocompleteNoPlaces' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hashtag' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'hashtagName' },
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'zoom' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharryKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameEn' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isSmallOrganisation' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullname' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AutocompleteNoPlacesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'autocompleteNoPlaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'autocompleteNoPlaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutocompleteNoPlaces' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutocompleteNoPlaces' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutocompleteNoPlaces' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hashtag' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'hashtagName' },
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'zoom' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharryKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameEn' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'workAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isSmallOrganisation' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullname' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class AutocompleteNoPlacesGQL extends Apollo.Query<
  AutocompleteNoPlacesQuery,
  AutocompleteNoPlacesQueryVariables
> {
  document = AutocompleteNoPlacesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const UserSearchesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userSearches' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchString' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'searchUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class UserSearchesGQL extends Apollo.Query<UserSearchesQuery, UserSearchesQueryVariables> {
  document = UserSearchesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const SuggestedSearchesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'suggestedSearches' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedSearches' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'key' },
                      value: { kind: 'StringValue', value: 'sort', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '5' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchString' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'searchUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class SuggestedSearchesGQL extends Apollo.Query<SuggestedSearchesQuery, SuggestedSearchesQueryVariables> {
  document = SuggestedSearchesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const HeaderCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'headerCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'key' },
                      value: { kind: 'StringValue', value: 'sort', block: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'direction' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequencySort' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previewImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class HeaderCategoriesGQL extends Apollo.Query<HeaderCategoriesQuery, HeaderCategoriesQueryVariables> {
  document = HeaderCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
